import {
  Search,
  CheckCircle,
  Bot,
  Timer,
  TrendingUp,
  TrendingDown,
  Smartphone,
  Laptop,
  Wrench,
  DollarSign,
  ShoppingCart,
  Grid,
  ShoppingBag,
  QrCode,
} from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import { Link } from "react-router-dom";
function Dashboard({ onViewClaims }) {
  const statsCards = [
    {
      title: "Revenue",
      value: "$13,456.5",
      icon: DollarSign,
      iconColor: "text-white",
      bgColor: "bg-warning bg-opacity-10",
      trend: "+12%",
      trendDirection: "up",
      trendLabel: "Shipping fees are not included.",
    },
    {
      title: "Orders",
      value: "53",
      icon: ShoppingCart,
      iconColor: "text-white",
      bgColor: "bg-success bg-opacity-10",
      trend: "+8%",
      trendDirection: "up",
      trendLabel: "Excluding orders in transit",
    },
    {
      title: "Products",
      value: "100",
      icon: QrCode,
      iconColor: "text-white",
      bgColor: "bg-info bg-opacity-10",
      trend: "+2.1%",
      trendDirection: "up",
      trendLabel: "In 5 Categories",
    },
    {
      title: "Monthly Earning",
      value: "$6,982",
      icon: ShoppingBag,
      iconColor: "text-white",
      bgColor: "bg-xaxathrive-primary bg-opacity-10",
      trend: "-0.3h",
      trendDirection: "down",
      trendLabel: "Based in your local time.",
    },
  ];

  const orders = [
    {
      id: "#SK2540",
      name: "Neal Matthews",
      date: "07 Oct, 2021",
      total: "$400",
      status: "Paid",
      method: "Mastercard",
    },
    {
      id: "#SK2541",
      name: "Jamal Burnett",
      date: "07 Oct, 2021",
      total: "$380",
      status: "Chargeback",
      method: "Visa",
    },
    {
      id: "#SK2542",
      name: "Juan Mitchell",
      date: "06 Oct, 2021",
      total: "$384",
      status: "Paid",
      method: "Paypal",
    },
    {
      id: "#SK2543",
      name: "Barry Dick",
      date: "05 Oct, 2021",
      total: "$412",
      status: "Paid",
      method: "Mastercard",
    },
    {
      id: "#SK2544",
      name: "Ronald Taylor",
      date: "04 Oct, 2021",
      total: "$404",
      status: "Refund",
      method: "Visa",
    },
    {
      id: "#SK2545",
      name: "Jacob Hunter",
      date: "04 Oct, 2021",
      total: "$392",
      status: "Paid",
      method: "Paypal",
    },
  ];

  // Status badge color map
  const statusColors = {
    Paid: "success",
    Refund: "warning",
    Chargeback: "destructive",
  };
  return (
    <div className="space-y-4">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {statsCards.map((stat) => {
          const Icon = stat.icon;
          const TrendIcon =
            stat.trendDirection === "up" ? TrendingUp : TrendingDown;

          return (
            <Card key={stat.title} className="shadow-sm">
              <CardContent className="!p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-slate-600">
                      {stat.title}
                    </p>
                    <p className="text-3xl font-bold text-slate-900">
                      {stat.value}
                    </p>
                  </div>
                  <div
                    className={`w-12 h-12 ${stat.bgColor} rounded-lg flex items-center justify-center`}
                  >
                    <Icon className={stat.iconColor} size={24} />
                  </div>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <span className="text-sm text-slate-500">
                    {stat.trendLabel}
                  </span>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="shadow-sm">
        <CardHeader className="!p-4">
          <div className="flex items-center justify-between">
            <CardTitle className="text-xl">Latest orders</CardTitle>
            <Button
              variant="link"
              className="text-xaxathrive-primary hover:text-blue-700"
            >
              View all orders
            </Button>
          </div>
        </CardHeader>
        <CardContent className="!pt-0 !p-4">
          <div className="flex flex-col lg:flex-row gap-4 pb-4">
            <div className="flex-1 relative">
              <Search
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400"
                size={16}
              />
              <Input
                placeholder="Search by ID, or product..."
                className="pl-10"
              />
            </div>
            <div className="flex gap-3">
              <Input
                type="date"
                placeholder="dd-mm-yyyy"
                style={{ minWidth: 170 }}
              />
              <Select>
                <SelectTrigger style={{ minWidth: 160 }}>
                  <SelectValue placeholder="All Categories" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Categories</SelectItem>
                  <SelectItem value="Skin">Skin</SelectItem>
                  <SelectItem value="hair">Hair Regrowth</SelectItem>
                  <SelectItem value="Sexual">Sexual Health</SelectItem>
                  <SelectItem value="weight">Weight Loss</SelectItem>
                  <SelectItem value="Mental">Mental Health</SelectItem>
                  {/* Add more categories here */}
                </SelectContent>
              </Select>
              <Select>
                <SelectTrigger className="w-40">
                  <SelectValue placeholder="All Statuses" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Statuses</SelectItem>
                  <SelectItem value="active">Active</SelectItem>
                  <SelectItem value="expired">Expired</SelectItem>
                  <SelectItem value="suspended">Suspended</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="bg-gray-50">
                  <input type="checkbox" />
                </TableHead>
                <TableHead className="bg-gray-50">Order ID</TableHead>
                <TableHead className="bg-gray-50">Billing Name</TableHead>
                <TableHead className="bg-gray-50">Date</TableHead>
                <TableHead className="bg-gray-50">Total</TableHead>
                <TableHead className="bg-gray-50">Payment Status</TableHead>
                <TableHead className="bg-gray-50">Payment Method</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {orders.map((order) => (
                <TableRow key={order.id}>
                  <TableCell>
                    <input type="checkbox" />
                  </TableCell>
                  <TableCell>
                    <Link to={`/orderdetails/${order.id}`}>
                      <p className="font-medium text-slate-900">{order.id}</p>
                    </Link>
                  </TableCell>
                  <TableCell>{order.name}</TableCell>
                  <TableCell>{order.date}</TableCell>
                  <TableCell>{order.total}</TableCell>
                  <TableCell>
                    <Badge
                      variant={statusColors[order.status] || "secondary"}
                      className={
                        order.status === "Paid"
                          ? "bg-green-100 text-green-600"
                          : order.status === "Refund"
                          ? "bg-yellow-100 text-yellow-800"
                          : order.status === "Chargeback"
                          ? "bg-red-100 text-red-600"
                          : ""
                      }
                    >
                      {order.status}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <span className="inline-flex items-center gap-2">
                      <i className="ri-bank-card-line" /> {order.method}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
export default Dashboard;
